import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Flow Rate List with Query (for remote operations)
export const getWaterFlowRateListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_FLOW_RATE_LISTS}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Flow Rate List with Query
export const getWaterFlowRateList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['createdAt:desc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_FLOW_RATE_LISTS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Flow Rate List
export const getWaterFlowRateListItem = (water_flow_rate_list_id, populate = []) => {
	const populateParam = populate.length > 0 ? `?${stringifyParams({ populate })}` : '';
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_FLOW_RATE_LIST}${water_flow_rate_list_id}${populateParam}`
	);
};

// Add New Water Flow Rate List Item
export const addNewWaterFlowRateListApi = water_flow_rate_list => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_FLOW_RATE_LIST}`,
		water_flow_rate_list
	);
};

// Update Water Flow Rate List Item
export const updateWaterFlowRateListApi = water_flow_rate_list => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_FLOW_RATE_LIST}${water_flow_rate_list._id}`,
		water_flow_rate_list
	);
};

// Delete Water Flow Rate List Item
export const deleteWaterFlowRateListApi = water_flow_rate_list_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_FLOW_RATE_LIST}${water_flow_rate_list_id}`
	);
};
